import type { Action } from 'state/actions';
import { addOrPatchKey, removeKey } from 'state/utils/collection';
import { fromBcsProductKey } from 'state/workspaces/secondary-market/quotes/secondartMarketQuotes.shared';

import type { RealtimeMap, TrackedValue } from './realtime.model';
import { initialRealtimeMap } from './realtime.model';

export function realtimeReducer(state: RealtimeMap = initialRealtimeMap, action: Action): RealtimeMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_PRICE_RECEIVED':
      const key = fromBcsProductKey(action.bcsProductKey)!;
      return addOrPatchKey(state, key, s => ({
        bidUpfrontAndSalesMargin: action.price.bidUpfrontAndSalesMargin,
        askUpfrontAndSalesMargin: action.price.askUpfrontAndSalesMargin,
        unitSettlementPrice: action.price.unitSettlementPrice,
        referencePrice: action.price.referencePrice,
        bidSettlementPrice: updateTrackedValue(s.bidSettlementPrice, action.price.bidSettlementPrice),
        askSettlementPrice: updateTrackedValue(s.askSettlementPrice, action.price.askSettlementPrice),
        salesMargin: action.price.salesMargin,
        extLimitTime: action.price.extLimitTime,
        quoteStatus: action.price.quoteStatus,
      }));
    case 'SECONDARY_MARKET_PRICE_CLEARED':
      return removeKey(state, fromBcsProductKey(action.bcsProductKey)!);

    default:
      return state;
  }
}
const definedValue = (v?: number) => v ?? 0;
function updateTrackedValue(previousValue?: TrackedValue, newValue?: number): TrackedValue | undefined {
  if (newValue === previousValue?.value || previousValue?.value === undefined) {
    return { value: newValue, trend: 'stagnate' };
  } else if (definedValue(newValue) > definedValue(previousValue?.value)) {
    return { value: newValue, trend: 'increase' };
  } else if (definedValue(newValue) < definedValue(previousValue?.value)) {
    return { value: newValue, trend: 'decrease' };
  }
}
